import { BoxProps } from '@mui/material';
import { IAIAssistantType, IAIResponseType } from 'constants/AI';

import { ObjectValues } from 'interfaces/files';

export const FORM_SECTION_CARD_VARIANT = {
  SMALL: 'small',
  LARGE: 'large',
} as const;

export type IFormSectionCardVariant = ObjectValues<typeof FORM_SECTION_CARD_VARIANT>;

export interface IFormContainerProps extends BoxProps {
  title?: string;
  subtitle?: string;
  disabled?: boolean;
  collapsible?: boolean;
  requiredForAI?: boolean;
  variant?: IFormSectionCardVariant;
  titleWrapperClassName?: string;

  aiFieldName?: string | string[];
  aiFieldType?: IAIResponseType;
  aiOnlyUpdate?: boolean;
  aiGenerateCallback?: (aiGenerateFunction: (aiAssistantType: IAIAssistantType) => Promise<void>) => void
}
